(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Header-section (met .section-header)
      this.headerSection = this.closest('.section-header') || this;
      if (!this.headerSection) return;

      // Alle sections die in de header-group vallen (announcement bar + header)
      this.headerGroupSections = document.querySelectorAll(
        '.shopify-section-group-header-group'
      );

      this.headerIsAlwaysSticky =
        this.dataset.stickyType === 'always' ||
        this.dataset.stickyType === 'reduce-logo-size';

      this.headerBounds = { top: 0, bottom: 0 };

      this.initialHideBehavior = this.dataset.initialHide || 'never';
      this.isProductPage =
        document.body.classList.contains('template-product') ||
        window.location.pathname.includes('/products/');

      this.initiallyHidden = false;
      this.initialHideApplied = false;

      this.setHeaderHeight();
      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.headerSection.classList.add('shopify-section-header-sticky');
      }

      // >>> Initial hide: volledige header-group verbergen (incl. announcement bar)
      const shouldInitialHide =
        !this.headerIsAlwaysSticky &&
        (this.initialHideBehavior === 'all' ||
          (this.initialHideBehavior === 'product_only' && this.isProductPage));

      if (shouldInitialHide) {
        this.initiallyHidden = true;
        this.initialHideApplied = true;

        this.headerGroupSections.forEach((section) => {
          section.classList.add('scrolled-past-header');
          // visueel omhoog + layout dicht
          section.style.transform = 'translateY(-100%)';
          section.style.height = '0px';
          section.style.overflow = 'hidden';
        });

        this.headerSection.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );
      } else {
        // Geen initial hide → zorg dat er geen leftovers zijn
        this.headerGroupSections.forEach((section) => {
          section.style.transform = '';
          section.style.height = '';
          section.style.overflow = '';
        });
      }
      // <<< einde initial hide

      this.currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.headerSection) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.headerSection.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.headerSection) return;

      const observer = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Zolang we bovenaan zijn en initial hide actief is, niks doen
      if (this.initiallyHidden && scrollTop === 0) {
        this.currentScrollTop = scrollTop;
        return;
      }

      // Zodra er beweging is, is de "initial hide"-fase voorbij
      if (this.initiallyHidden && scrollTop > 0) {
        this.initiallyHidden = false;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // omlaag scrollen
        this.headerSection.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        // omhoog scrollen
        this.headerSection.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        // weer helemaal bovenaan
        this.headerSection.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || !this.headerSection) return;

      this.headerSection.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      // bij scroll-down alleen visueel omhoog, layout blijft staan
      this.headerSection.style.transform = 'translateY(-100%)';

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky || !this.headerSection) return;

      // Eerste keer uit initial hide → hele group layout herstellen
      if (this.initialHideApplied) {
        this.headerGroupSections.forEach((section) => {
          section.style.height = '';
          section.style.overflow = '';
          section.style.transform = '';
        });
        this.initialHideApplied = false;
      }

      this.headerSection.classList.add('shopify-section-header-sticky', 'animate');
      this.headerSection.classList.remove('shopify-section-header-hidden');

      // **Belangrijk**: CSS height/transform overriden
      this.headerSection.style.height = 'auto';
      this.headerSection.style.overflow = 'visible';
      this.headerSection.style.transform = 'translateY(0)';
    }

    reset() {
      if (this.headerIsAlwaysSticky || !this.headerSection) return;

      if (this.initialHideApplied) {
        this.headerGroupSections.forEach((section) => {
          section.style.height = '';
          section.style.overflow = '';
          section.style.transform = '';
        });
        this.initialHideApplied = false;
      }

      this.headerSection.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );

      this.headerSection.style.height = 'auto';
      this.headerSection.style.overflow = 'visible';
      this.headerSection.style.transform = 'translateY(0)';
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.headerSection.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.headerSection.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
